export default __webpack_public_path__ + "static/media/39.66bd3638.png";